import { getListViewTypeString, getListViewTypeForFolder } from 'owa-mail-list-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getListViewTypeForGroup } from 'owa-group-mail-list-actions';
export { ReactListViewType };
export default {
    switchMailFolderDatapoint: {
        datapoint: {
            name: 'SwitchMailFolder',
            options: {
                enablePerformanceMarks: true,
                isQos: true,
                variant: 2 /* WarmOnly */,
            },
            customData: function (folderId, treeType, previousFolderId, actionSource) { return [
                folderIdToName(folderId),
                previousFolderId ? folderIdToName(previousFolderId) : '',
                treeType,
                folderId,
                actionSource,
                getListViewTypeString(getListViewTypeForFolder(folderId)),
            ]; },
        },
    },
    selectPersona: {
        datapoint: {
            name: 'SelectPersona',
        },
    },
    selectPersonaWithSearchFallback: {
        datapoint: {
            name: 'TnS_SelectPersonaWithSearchFallback',
        },
    },
    selectPrivateDistributionList: {
        datapoint: {
            name: 'SelectPrivateDistributionList',
        },
    },
    selectFavoriteSearch: {
        datapoint: {
            name: 'TnS_SelectFavoriteSearch',
        },
    },
    selectFavoriteCategory: {
        datapoint: {
            name: 'TnS_SelectFavoriteCategory',
        },
    },
    switchGroupDatapoint: {
        datapoint: {
            name: 'SwitchGroup',
            options: {
                doNotSample: true,
                isQos: true,
            },
            customData: function (groupId, treeType) { return ({
                TreeType: treeType,
                ListViewType: getListViewTypeString(getListViewTypeForGroup()),
            }); },
        },
    },
    navigateFromMeToWeDatapoint: {
        datapoint: {
            name: 'NavigateFromMeToWe',
            options: {
                doNotSample: true,
                isQos: true,
            },
            customData: function (groupId, treeType) { return ({
                TreeType: treeType,
                ListViewType: getListViewTypeString(getListViewTypeForGroup()),
            }); },
        },
    },
    personaClicked: {
        datapoint: {
            name: 'PersonaClicked',
            customData: function (favoriteNodeId, unreadCount) { return [
                unreadCount,
                favoriteNodeId,
            ]; },
        },
    },
    privateDistributionListClicked: {
        datapoint: {
            name: 'PrivateDistributionListClicked',
            customData: function (favoriteNodeId, unreadCount) { return [
                unreadCount,
                favoriteNodeId,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map